const CDN_BASE = 'https://cdn.moglix.com/';
const PRODUCT_BASE = 'https://www.moglix.com/';

export const toProductImageUrl = (link?: string): string | undefined => {
    if (!link) return undefined;
    return /^https?:\/\//i.test(link) ? link : `${CDN_BASE}${link}`;
};

export const toProductPageUrl = (link?: string): string | undefined => {
    if (!link) return undefined;
    if (/^https?:\/\//i.test(link)) {
        try {
            const { pathname, search } = new URL(link);
            return `${PRODUCT_BASE}${pathname.replace(/^\/+/, '')}${search}`;
        } catch {
            return link;
        }
    }
    return `${PRODUCT_BASE}${link.replace(/^\/+/, '')}`;
};
